import type { IntlShape } from 'react-intl'
import type { CurrencyHeader } from './types'

export const currencyHeaders: CurrencyHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency', //TODO:
		show: true,
		sortable: true,
		type: 'string',
		fullWidth: true,
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Marginaali',
				description: 'Table column header: Marginal',
			}),
		key: 'marginal', //TODO:
		show: true,
		sortable: true,
		type: 'number',
		fullWidth: true,
	},
]
